export const validatePhoneNum = (value) => {
  const result = String(value).match(/\(\d\d\d\) \d\d\d-\d\d\d\d/)
  if(!result) return false
  else return true
}


export const validateSsn = (ssn) => {
  const result = String(ssn).match(/\d\d\d-\d\d-\d\d\d\d/)
  if(!result) return false
  else return true
}

export const validateName = (name) => {
  if(!name) return false

  const isValidName = name
     .replace(/\s+/g, " ")
     .split(" ")
     .filter(word => !!word)
     .length > 1;
  return isValidName
}
